module.exports = __webpack_public_path__ + "img/icb-empty-e@3x.7bc71a4a.png";